import React, { useEffect, useMemo, useState } from 'react';
import { getPlayerHeadshot } from '../../api/publicApi';

const PlayerCell = ({ firstName, lastName, country, headshotUrl }) => {
  const [headshot, setHeadshot] = useState(headshotUrl || null);

  const playerName = useMemo(
    () => `${firstName || ''} ${lastName || ''}`.trim() || '—',
    [firstName, lastName]
  );
  const fallbackInitial = (lastName || firstName || '?').trim().charAt(0).toUpperCase() || '?';

  useEffect(() => {
    if (headshotUrl) {
      setHeadshot(headshotUrl);
      return undefined;
    }

    let cancelled = false;
    setHeadshot(null);

    getPlayerHeadshot(firstName, lastName, country).then((url) => {
      if (!cancelled) setHeadshot(url);
    });

    return () => {
      cancelled = true;
    };
  }, [firstName, lastName, country, headshotUrl]);

  return (
    <span className="player-cell">
      <span className="player-avatar" aria-hidden>
        {headshot ? (
          <img src={headshot} alt="" className="player-avatar-img" loading="lazy" decoding="async" />
        ) : (
          <span className="player-avatar-initials">{fallbackInitial}</span>
        )}
      </span>
      <span className="player-name">{playerName}</span>
    </span>
  );
};

export default PlayerCell;
